export default type => {
  switch (type) {
    case 'satellite':
      return type
    case 'roadmap':
      return type
    case 'canvasMode':
      return 'blank'
    default:
      return console.log(`MAP TYPE NOT FOUND: ${type}`) || 'satellite'
  }
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/mapType.js